import BaseResponse from '@responses/BaseResponse'
class TranslationListResponse extends BaseResponse {
    constructor(translationList, responseCode) {
        super(responseCode)
        this.translationList = translationList
    }
}

export default TranslationListResponse
